<template>
  <section class="content">
    <div class="container-fluid">
        <div class="row">

          <div class="col-12">

            <div class="card">
              <div class="card-header">
                <h3 class="card-title"> Каталог продукции,  <span v-if="total">
                          записей {{ total }}
                      </span>
                </h3>

<!--                <div class="card-tools">-->

<!--                  <button type="button" class="btn btn-sm btn-primary" @click="newModal">-->
<!--                      <i class="fa fa-plus-square"></i>-->
<!--                      Добавить продукцию-->
<!--                  </button>-->
<!--                </div>-->
              </div>
              <!-- /.card-header -->

                <div class="form-inline">
                    <div class="form-group" style="float: right;padding: 1em;" >
                        <select v-model="length" @change="getResults()" class="form-control"
                                style="width: 12em">
                            <option value="">Количество полей</option>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select>

                    </div>
                </div>

              <div class="card-body table-responsive p-0">
                <table class="table">
                  <thead>

                    <tr>
                        <th><input type="number" v-model="search.id"  placeholder="id"
                                   class="form-control" @input="getResults()"></th>
                        <th></th>
                        <th><input type="text" v-model="search.name"
                                   placeholder="Наименование" class="form-control" @input="getResults()">
                        </th>
                        <th></th>
                        <th>
<!--                            <select class="form-control" v-model="search.cid" @change="getResults()">-->
<!--                                <option></option>-->
<!--                                <option-->
<!--                                    v-for="cat in categories" :key="cat"-->
<!--                                    :value="cat">-->
<!--                                    {{ cat }}-->
<!--                                </option>-->
<!--                            </select>-->
													<v-select
																	label="name"
																	:options="categories"
																	:reduce="(option) => option.id"
																	v-model="search.cid"
																	aria-required="true"
																	class="form-control"
																	@input="getResults()"
													/>
                        </th>
                        <th>
                            <button type="button" class="btn btn-sm btn-success" @click="clearSearchItem">

                                <i class="fa fa-trash "></i> Очистить
                            </button>
												</th>
											<th style="text-align: end">
                            <button type="button" class="btn btn-sm btn-primary" @click="newModal">
                                <i class="fa fa-plus-square"></i> Добавить
                            </button>
                        </th>
                    </tr>
                  </thead>
                </table>

                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th @click="getResults(current_page, 'id')">id
                        <button :tabindex="-1" aria-label="Sort " title="Sort "
                                :class="[ (sort.id=='ASC') ? 'transform' : 'transformold' ]"
                                class="gridjs-th gridjs-th-sort"></button>
                      </th>
                      <th>Фото</th>
                      <th @click="getResults(current_page, 'name')">Наименование
                        <button :tabindex="-1" aria-label="Sort " title="Sort "
                                :class="[ (sort.family=='ASC') ? 'transform' : 'transformold' ]"
                                class="gridjs-th gridjs-th-sort"></button>
                      </th>

                      <th @click="getResults(current_page, 'view')">Отображение
                        <button :tabindex="-1" aria-label="Sort " title="Sort "
                                :class="[ (sort.view=='ASC') ? 'transform' : 'transformold' ]"
                                class="gridjs-th gridjs-th-sort"></button>
                      </th>
                      <th @click="getResults(current_page, 'category')">Категория
                        <button :tabindex="-1" aria-label="Sort " title="Sort "
                                :class="[ (sort.category=='ASC') ? 'transform' : 'transformold' ]"
                                class="gridjs-th gridjs-th-sort"></button>
                      </th>
                        <th></th>
                    </tr>
                  </thead>
                  <tbody>
                     <tr v-for="product in products.data" :key="product.id">
                      <td>{{product.id}}</td>
                      <td>
                          <viewer :images="product.photo" :options="options">
                          <img :src='product.photo' style="width:80px">
                          </viewer>
                      </td>
                      <td>{{product.name}}</td>
                      <td>
                          <input type="checkbox" :checked="product.view" @click="checkboxToggle(product)">
                      </td>
                      <td>{{product.category}}</td>
                      <!-- <td><img v-bind:src="'/' + product.photo" width="100" alt="product"></td> -->
                      <td style="text-align: right">
                        <a href="#" @click="editModal(product.id);$refs.modal.openModal();">
                            <i class="fa fa-edit blue"></i>
                        </a>
                        /
                        <a href="#" @click="deleteProduct(product)">
                            <i class="fa fa-trash red"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.card-body -->
              <div class="card-footer">
                  <pagination :data="products" @pagination-change-page="getResults" :limit="5">
                      <span slot="prev-nav">&lt; Назад</span>
                      <span slot="next-nav">Вперед &gt;</span>
                  </pagination>
<!--                  <pagination :data="products" @pagination-change-page="getResults"></pagination>-->
              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>

        <!-- Modal -->
      <right-modal-widget  v-bind:id="'production-edit-modal'" v-bind:title="!editmode?'Создать запись':'Редактировать запись'" ref="modal">
                <form @submit.prevent="editmode ? updateProduct() : createProduct()">
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Наименование</label>
                            <input v-model="form.name" type="text" name="name"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                            <has-error :form="form" field="name"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Описание продукта:</label>
                            <textarea v-model="form.text" type="text" name="text" rows="8"
                                      class="form-control" :class="{ 'is-invalid': form.errors.has('text') }"></textarea>
                            <has-error :form="form" field="text"></has-error>
                        </div>
											<v-select
															label="name"
															:options="categories"
															:reduce="(option) => option.id"
															v-model="form.cid"
															aria-required="true"
															class="form-contros"
											/>
                        <div class="form-group">
                            <label>Показывать на сайте</label>
                            <input type="checkbox" :checked="form.view"  v-model="form.view">
                        </div>
                        <div class="form-group" style="padding: 0em">
<!--                            <label>Фото</label><br>-->
<!--                            <img :src='form.photo' v-if="!showPreview" style="width:3em">-->
<!--                                <img v-bind:src="imagePreview" style="width:3em" v-show="showPreview">-->
<!--                            <br>-->
<!--                            <br>-->
<!--                            <input type="file" id="file" ref="file" name="file"  accept="image/*" v-on:change="handleFileUpload()"/>-->
													<drop-input
																	ref="image"
																	type="image"
																	size="5"
																	crop="1280x800"
																	@file="icon(key, $event)"
													></drop-input>
                        </div>
											<div class="form-group">
												<div class="panel-heading">
													<h4>
														<label>Параметры позиции </label>
														<button type="button" class="add-item btn btn-success btn-sm pull-right"
																		@click="addItem()"><i class="fa fa-plus white"></i> Добавить
														</button>
													</h4>
												</div>
												<div class="container-items">
													<div class="row">
														<div class="col-5">Вес</div>
														<div class="col-5">Цена</div>
<!--														<div class="col-2">От.</div>-->
														<div class="col-2">#</div>
													</div>
													<div v-if="form.price.length>0">
												<div class="row"v-for="(price,key) in form.price "  v-if="!price.del " >
													<div class="col-5"><input v-model="price.weight" class="form-control" type="number" min="0" max="99999"></div>
													<div class="col-5"><input v-model="price.price" class="form-control" type="number" min="0" max="99999"></div>
<!--													<div class="col-2 centerall"><input type="checkbox" :checked="price.view"  v-model="price.view"></div>-->
													<div class="col-2"><button type="button" title="Удалить"
																										 class="btn btn-danger btn-sm input-group-addon"
																										 @click="removeItem(key)">
														<i class="fa fa-minus white"></i>
													</button>
													</div>
												</div>
													</div>
												</div>
                    </div>
                    </div>
                    <div class="modal-footer">
                        <button v-show="editmode" type="submit" class="btn btn-success">Обновить</button>
                        <button v-show="!editmode" type="submit" class="btn btn-primary">Создать</button>
                    </div>
                  </form>
      </right-modal-widget>
    </div>
  </section>
</template>

<script>
    import VueTagsInput from '@johmun/vue-tags-input';

    export default {
      components: {
          VueTagsInput,
        },
        data () {
            return {
                editmode: false,
						  	file: false,
                products : {},
                form: new Form({
                    id : '',
                    cid : '',
                    name: '',
                    text: '',
                    view: '',
                    photo: '',
                    price: [],
                    photoUrl: '',
                }),
                search: {
                    id: '',
                    name: '',
                    cid: '',
                },
              sort: {
                id: 'ASC',
                name: 'ASC',
                category: 'ASC',
              },
                length: '',
                total: '',
                current_page: '',
                categories: [],
                options: {
                    toolbar: false,
                    navbar: false,
                },
                showPreview: false,
                imagePreview: '',
                autocompleteItems: [],
							urls: {
								getdata: "/api/product?page=",
								update: "/api/product/update",
								create: "/api/product",
								show: "/api/product/",
								check: "/api/product/check",
								category: "/api/category/list",
								delete: "/api/product/",
							},
            }
        },
        methods: {
					removeItem(key) {
						//this.form.price.splice(key, 1);
						this.form.price[key].del=1
						this.$forceUpdate();
						return;
					},
					addItem() {
						this.form.price.push({});
					},

					icon(key,file) {
						this.file= file ;
					},
            handleFileUpload(){
                this.file = this.$refs.file.files[0];
                let reader  = new FileReader();
                reader.addEventListener("load", function () {
                    this.showPreview = true;
                    this.imagePreview = reader.result;
                }.bind(this), false);
                if( this.file ){
                    if ( /\.(jpe?g|png|gif)$/i.test( this.file.name ) ) {
                        reader.readAsDataURL( this.file );
                    }
                  }
                },
            checked(){},
            clearSearchItem() {
                this.search.id = '';
                this.search.name = '';
                this.search.category = '';
                this.sortable='DESK';
                this.sort='id';

                this.getResults(1);
            },
            checkboxToggle(val){
                if( val['view'] == 'checked'){
                    var view=null;
                }else {
                    var view='checked';
                }
                axios.post(this.urls.check, {
                    id: val['id'],
                    name: val['name'],
                    category_id: val['category_id'],
                    view: view,
                    smalltext: val['smalltext'],
                    text: val['text'],
                    photo: val['photo'],
                })
                    .then((data)=>{
                        if(data.data.success){
                            Toast.fire({
                                icon: 'success',
                                title: data.data.message
                            });
                            this.$Progress.finish();
                            this.loadProducts();

                        } else {
                            Toast.fire({
                                icon: 'error',
                                title: 'Ошибка'
                            });
                            this.$Progress.failed();
                        }
                    })
            },

          fsort(name) {
            if (this.sort[name] == 'ASC') {
              this.sort[name] = 'DESC';
            } else {
              this.sort[name] = 'ASC'
            }
          },
          async getResults(page, sort) {
            this.fsort(sort);
            if (page == undefined) {
              page = this.current_page;
            } else {
              this.current_page = page;
            }
              this.$Progress.start();
              axios.get(this.urls.getdata + page, {
                  params: {
                      sort: sort,
                      sortable: this.sortable,
                      pagination: this.length,
                      search: this.search
                  }
              }).then(({ data }) => (this.products = data.data, this.sortable = data['message'], this.length = data.data.per_page, this.total = data.data.total, this.current_page = data.data.current_page));
           // console.log(this.sortable);
              this.$Progress.finish();
          },
          loadCategories(){
              axios.get(this.urls.category).then(({ data }) => (this.categories = data.data));
          },
					editModal(id) {
						var app = this;
						app.editmode = true;
						app.form.reset();
						axios
										.get(app.urls.show + id)
										.then(function (result) {
											if (result.data.success == true) {
												var item = result.data.data;
												app.form.id = item.id;
												app.$refs.image.data(item.photo);
												app.form.name = item.name;
												app.form.text = item.text;
												app.form.view = item.view;
												app.form.cid = item.cid;
												app.form.price = item.price;
											} else if (result.data.status == 'error') {
												this.toastError(errors.response.data.description);
											}
											app.$forceUpdate();
											app.editmode= true;
											app.$refs.rightModalWidget.openModal();
										})
										.catch(function (error) {
											//	this.toastError(errors.response.data.errors);
										});
					},
          newModal(){
              this.editmode = false;
              this.form.reset();
						 this.$refs.image.removeFile();
					 	this.$refs.modal.openModal();
            },
          createProduct(){
              this.$Progress.start();

              let formData = new FormData();
              formData.append('file', this.file);

            //  this.form.post('api/product')
              axios.post(this.urls.create,
                  formData, {
                      params: {
                          current_page: this.current_page,
                          name: this.form.name,
                          text: this.form.text,
                          view: this.form.view,
                          photo: this.form.photo,
                          cid: this.form.cid,
											   	price: this.form.price,
                      },
                      headers: {
                          'Content-Type': 'multipart/form-data'
                      }
                  })
                  .then((response) => {
                      // success
                      $('#addNew').modal('hide');
                      Toast.fire({
                          icon: 'success',
                          title: response.data.message
                      });
                      this.$Progress.finish();
										this.$refs.modal.closeModal();

										this.getResults(response.data.data);
                  })
                  .catch(() => {
                      this.$Progress.fail();
                  });
          },
          updateProduct(){
              this.$Progress.start();

            let formData = new FormData();
              formData.append('file', this.file);

              //this.form.
              axios.post(this.urls.update,
                  formData, {
                  params: {
                      current_page: this.current_page,
                      id: this.form.id,
                      name: this.form.name,
                      text: this.form.text,
                      view: this.form.view,
                      photo: this.form.photo,
                      cid: this.form.cid,
										  price: this.form.price,
                  },
                  headers: {
                      'Content-Type': 'multipart/form-data'
                  }
              })
              .then((response) => {
                  // success
                  $('#addNew').modal('hide');
                  Toast.fire({
                    icon: 'success',
                    title: response.data.message
                  });
                  this.$Progress.finish();
                  this.$refs.modal.closeModal();

                this.getResults(response.data.data);
              })
              .catch(() => {
                  this.$Progress.fail();
              });

          },
          deleteProduct(product){
              Swal.fire({
                  title: 'Вы хотите удалить?',
                  text: product.name ,
                  imageUrl:  product.photo,
                  imageHeight: 200,
                  showCancelButton: true,
                  confirmButtonColor: '#d33',
                  cancelButtonColor: '#3085d6',
                  cancelButtonText: 'Отмена',
                  confirmButtonText: 'Удалить',
              }).then((result) => {
                      // Send request to the server
                        if (result.value) {
                            axios.delete(this.urls.delete+product.id,
                                 {
                                    params: {
                                        current_page: this.current_page,
                                    }}).then((response) => {
                                      Swal.fire(
                                      'Удаление!',
                                      'Успешно выполнено.',
                                      'success'
                                      );
                                  // Fire.$emit('AfterCreate');
                                  this.getResults(response.data.data.current_page);
                                    }).catch((data)=> {
                                  Swal.fire("Ошибка!", data.message, "warning");
                              });
                        }
                  })
          },
        },
        created() {
            this.$Progress.start();
            this.getResults();
            this.loadCategories();

            this.$Progress.finish();
        },
    }
</script>
<style>

</style>
